import { Component } from '@angular/core';
import { ItemsListContentBaseComponent } from '../content-base/content-base.component';

@Component({
    selector: 'fi-items-list-content-grid-view',
    templateUrl: './content-grid-view.component.html',
    styleUrls: ['./content-grid-view.component.scss'],
    standalone: false,
})
export class ItemsListContentGridViewComponent extends ItemsListContentBaseComponent {}
